import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createAsset } from "../../redux/actions/asset.actions";
import ListErrors from "../../components/ListErrors";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";
import {
  loadAssetAddPage,
  unloadAssetAddPage
} from "../../redux/actions/asset.actions";

const AssetSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, i18n.t("asset.form_name_invalid_error"))
    .required(i18n.t("asset.form_name_required_error")),
  site: Yup.string().required(i18n.t("asset.form_site_required_error"))
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function AssetAdd() {
  const [image, setImage] = useState(null);
  const dispatch = useDispatch();
  const asset = useSelector(state => state.asset);

  const query = useQuery();
  const from = query.get("from");
  const key = query.get("key");

  useEffect(() => {
    dispatch(loadAssetAddPage());
    return () => dispatch(unloadAssetAddPage());
  }, [dispatch]);

  const handleSubmit = (name, encoding, hash, site, image_source, phone) =>
    dispatch(createAsset(name, encoding, hash, site, image_source, phone));

  let history = useHistory();

  function handleClick() {
    history.push("/assets");
  }
  if (!asset.sites) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"assets"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"assets"} />
          <div id="content">
            <Header />
            <div className="content-wrap content-narrow">
              <div className="box-header">
                <a className="header-button" onClick={handleClick}>
                  {t("common.back")}
                </a>
                <h2>{t("asset.create_title")}</h2>
              </div>
              <Formik
                initialValues={{
                  name: "",
                  encoding: "",
                  hash: "",
                  site: from === "site" ? key : "",
                  phone: ""
                }}
                validationSchema={AssetSchema}
                onSubmit={(payload, { setSubmitting }) => {
                  handleSubmit(
                    payload.name,
                    payload.encoding,
                    payload.hash,
                    payload.site,
                    image,
                    payload.phone
                  );
                  setSubmitting(false);
                }}
              >
                {({ touched, errors, isSubmitting }) => (
                  <Form>
                    <div className={`form-item`}>
                      <label htmlFor="name">{t("asset.label_name")}</label>
                      <Field
                        name="name"
                        type="text"
                        placeholder={t("asset.input_name_placeholder")}
                      />
                      <ErrorMessage
                        name="name"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <div className={`form-item `}>
                      <label htmlFor="name">{t("asset.label_phone")}</label>
                      <Field
                        name="phone"
                        type="text"
                        placeholder="+61 54561111"
                      />
                      <ErrorMessage
                        name="phone"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="file">{t("asset.label_image")}</label>
                      <Field
                        name="file"
                        type="file"
                        accept="image/*"
                        onChange={e => setImage(e.target.files[0])}
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="encoding">
                        {t("asset.label_encoding")}
                      </label>
                      <Field
                        name="encoding"
                        component="textarea"
                        placeholder=""
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="hash">{t("asset.label_hash")}</label>
                      <Field name="hash" type="text" placeholder="" />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="name">{t("common.site")}</label>
                      <Field as="select" name="site">
                        <option value={""}>
                          {t("common.option_select_site")}
                        </option>
                        {asset.sites.map(item => {
                          return <option value={item.key}>{item.name}</option>;
                        })}
                      </Field>
                      <ErrorMessage
                        name="site"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <ListErrors errors={asset.errors} />
                    <div className="form-item">
                      <button type="submit" disabled={isSubmitting}>
                        {isSubmitting
                          ? t("system.submitting_feeback")
                          : t("asset.create_button")}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}
export default AssetAdd;
